import { Colors as foundationColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const Colors = {
  loginBox: foundationColors.blackTwo,
  bubbleView: foundationColors.blackTwo,
  bubbleViewText: foundationColors.white,
  loadingText: foundationColors.white,
  codeInputText: foundationColors.white,
  textInput: {
    baseColor: foundationColors.very_light_grey,
    tintColor: foundationColors.blue_three,
    error: foundationColors.tangerine,
    helperTextColor: foundationColors.veryLightPink,
    textColor: foundationColors.white,
    activeColor: foundationColors.blue_three,
    inActiveColor: foundationColors.veryLightPink,
    selectionColor: {
      ios: foundationColors.warm_grey_two,
      android: foundationColors.warm_grey_two,
    },
  },
  biometricText: foundationColors.fresh_orange,
  biometricIcon: foundationColors.fresh_orange,
  biometricTextDisabled: foundationColors.veryLightPink,
  biometricIconDisabled: foundationColors.veryLightPink,
};

export default Colors;
